/**
 * Zeniora Promo Engine - 促销活动全局业务配置文件
 * 
 * 职责：
 * 提供全站促销模块的核心业务开关、门槛设定、推荐数据来源、文案自定义。
 * 修改此文件可直接调整前台促销展示与文案行为。
 */

window.ZenioraPromoConfig = {
  // ----------------------------------------------------
  // 1. 满额免邮活动配置 (Free Shipping Threshold)
  // ----------------------------------------------------
  freeShipping: {
    enabled: true,
    threshold: 5900, // 免邮金额门槛，单位：分 (cents)。例如 5900 代表 $59.00

    // 凑单推荐商品数据来源 (可以配 Collection handle，也可以配置静态商品列表)
    recommendations: {
      // 如果配置了 collectionHandle，引擎会首选拉取此 Collection 的商品作为凑单品
      collectionHandle: 'all',

      // 静态推荐商品列表（在 Storefront API 请求失败或 Collection 未加载成功时作为兜底）
      fallbackProducts: [
        {
          handle: 'classic-elegant-bracelet',
          title: 'Classic Elegant Bracelet'
        },
        {
          handle: 'crystal-pendant-necklace',
          title: 'Crystal Pendant Necklace'
        }
      ]
    }
  },

  // ----------------------------------------------------
  // 2. B2G1 / 组合买赠活动配置 (B2G1 Campaign)
  // ----------------------------------------------------
  b2g1Rules: [
    {
      id: 'b2g1-collection-campaign-2026',
      enabled: true,
      type: 'B2G1', // 活动类型：买二送一 (B2G1)

      // 指定可触发 B2G1 的商品 Collection Handle
      triggerCollectionHandle: 'all-products',

      // 配对商品特惠价信息（折后促销价，0代表免费）
      pairedProductPromoPrice: 0,

      // PDP 页面提示语（显示在加购按钮上方/下方，增强用户 B2G1 认知）
      pdpNotice: 'Buy 2, Get 1 Free! Frequently Bought Together',
      pdpButtonText: 'Add all 3 to Cart',

      // 购物车缺项提示语（当购物车里有主商品，但数量不足 3 件时展示，{count} 会被替换为所需件数）
      cartNotice: 'Buy 2 get 1! Add {count} more item(s) to unlock',

      // 活动成功提示语（当满足 3 件 or 以上触发商品加入购物车时展示）
      successNotice: '🎉 Congrats! You\'ve unlocked B2G1 discount!'
    }
  ],

  // ----------------------------------------------------
  // 3. 全局通用设置
  // ----------------------------------------------------
  generalSettings: {
    currencySymbol: '$', // 货币符号
    debug: false          // 是否开启控制台日志输出，便于开发调试
  },

  // ----------------------------------------------------
  // 4. 国际化与文案中心 (Language & Copywriting Settings)
  // ----------------------------------------------------
  languageSettings: {
    // 促销进度条与里程碑文案
    progressBar: {
      b2g1Incomplete: 'Buy 2 get 1, add {count} more item(s) to unlock',
      b2g1CompleteOnly: '🎉 B2G1 unlocked!',
      shippingIncompletePrefix: ' Only {remaining} away from FREE SHIPPING!',
      b2g1AndShippingIncomplete: '🎉 B2G1 unlocked! 🚚 Only <strong class="zeniora-highlight">{remaining}</strong> away from <strong>FREE SHIPPING</strong>!',
      b2g1SuccessNotice: '🎉 Congrats! You\'ve unlocked B2G1 discount (cheapest item is FREE)!',
      shippingSuccessNotice: '🎉 Congrats! You\'ve unlocked <strong>FREE SHIPPING</strong>!',
      milestoneB2g1Label: 'B2G1',
      milestoneShippingLabel: 'FREE SHIPPING'
    },
    // 购物车推荐凑单区文案
    cartUpsell: {
      b2g1Title: 'You Might Also Like',
      b2g1Subtitle: '',
      b2g1ItemBadge: 'B2G1',
      shippingTitle: 'You Might Also Like',
      shippingSubtitle: '',
      addButtonText: 'Add'
    },
    // PDP 详情页加购盒子文案
    pdpBundle: {
      badgeText: 'B2G1',
      pairedLabel: 'Recommended',
      primaryLabel: 'This item',
      thumbnailsLabel: 'Select accessory:',
      summaryLabel: 'Bundle Offer Price:',
      buyButtonText: 'Add all 3 to Cart'
    }
  }
};
